
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onewaytaxifrompune() {



    const cardData =
    {
        keyword: 'One Way Taxi from Pune',
        heading: 'Platinum24 Cabs: One Way Taxi from Pune',
        headingDescription: ' Platinum24 Cabs provides affordable One Way Taxi from Pune, ideal for travelers who need a convenient drop to nearby cities and towns without return charges. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures comfortable and safe travel for individuals, families, and corporate clients. With professional chauffeurs, timely pickups, and transparent fares, we make one-way journeys smooth and stress-free. Whether you’re heading to Mumbai, Shirdi, Nashik, Kolhapur, or other destinations, Platinum24 Cabs guarantees 24/7 availability, reliable service, and hassle-free one-way taxi travel from Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. Once the seat of the Maratha Empire, it showcases grand gateways, fountains, and gardens. Though partially destroyed by fire in 1828, its ruins still narrate tales of Bajirao and Mastani. The evening light-and-sound show recreates Maratha history. Tourists love exploring its majestic corridors and courtyards. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a majestic monument with Italian arches and sprawling gardens. It is historically significant as Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. The palace houses a museum displaying Gandhi’s personal items and photographs. Its calm ambiance attracts history and peace seekers. The palace is also a memorial to Kasturba Gandhi. Aga Khan Palace is Pune’s historic gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. The fort sits atop a hill, offering trekking trails and panoramic views of the Sahyadris. Visitors explore bastions, temples, and memorials that echo Maratha valor. Monsoon adds mist and waterfalls, enhancing its beauty. Local villagers serve rustic delicacies like pithla-bhakri at the top. Sinhagad is Pune’s perfect blend of history and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous shrine dedicated to Lord Ganesha. The magnificent idol is adorned with gold and ornaments, attracting devotees year-round. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. It is also known for charitable and cultural initiatives. The vibrant spiritual aura makes it a must-visit. Dagdusheth Temple is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is dedicated to Lord Shiva. It features rock-cut architecture with massive stone pillars, a sanctum, and a Nandi mandapa. Located in the city center, it offers a peaceful retreat from urban life. Evening prayers and chants create a mystical ambiance. Its ancient carvings reflect early Indian craftsmanship. Pataleshwar is Pune’s hidden spiritual heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a cultural treasure showcasing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, musical instruments, sculptures, and daily-use antiques. The recreated Mastani Mahal is the highlight for visitors. History lovers and students find it fascinating and educational. The museum preserves centuries of Indian culture and traditions. It is Pune’s proud showcase of heritage and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers a panoramic view of the city. At the hilltop stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the temple, making it a mix of devotion and adventure. The site also houses smaller shrines and a museum. Sunrise and sunset views are mesmerizing from here. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for spirituality and wellness. Spread across lush gardens, it attracts seekers from around the world. The ashram offers meditation, yoga, and personal growth workshops. Japanese Zen gardens and peaceful meditation halls add to its charm. Visitors experience rejuvenation and mindfulness here. Osho Ashram is Pune’s international wellness destination."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and lush green lawns. Families enjoy peaceful walks, photography, and picnics here. The garden symbolizes Indo-Japanese cultural friendship. Seasonal flowers and manicured spaces attract nature lovers. Pu La Deshpande Garden is Pune’s green oasis of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend destination near Pune. It supplies water to the city while offering scenic views of hills and flowing waters. Monsoon transforms it into a picturesque spot with overflowing streams. Street vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],



     "services": [
    {
      "name": "One Way Taxi Pune",
      "description": "Experience hassle-free travel with our One Way Taxi service in Pune, designed for convenience and comfort. Whether you're heading out for a business meeting, airport transfer, or a personal trip, our one-way taxi options provide flexibility without the worry of round-trip bookings. Travel smoothly with professional drivers and well-maintained vehicles at affordable rates."
    },
    {
      "name": "Pune One Way Cab Service",
      "description": "Our Pune One Way Cab Service offers a perfect solution for travelers who need reliable transportation from Pune to any destination without return journey hassles. Ideal for city-to-city travel, airport drops, or long-distance journeys, our cabs ensure timely pickups, safe rides, and courteous drivers for a stress-free experience."
    },
    {
      "name": "One Way Car Rental Pune",
      "description": "Rent a car on a one-way basis in Pune to match your travel plans exactly. Whether it’s a corporate trip, family visit, or holiday getaway, choose from a variety of cars, including sedans, SUVs, and luxury options. Our one-way car rental services are transparent, budget-friendly, and easy to book online."
    },
    {
      "name": "Affordable One Way Taxi Pune",
      "description": "Get the best deals on one way taxi services in Pune with our affordable rates that don’t compromise on quality or comfort. Enjoy transparent pricing with no hidden charges, fuel-efficient cars, and experienced drivers who prioritize your safety and convenience."
    },
    {
      "name": "Pune One Way Taxi Booking",
      "description": "Book your one-way taxi in Pune easily through our online platform or phone service. With instant confirmation, flexible payment options, and 24/7 availability, your one-way taxi journey is just a click away. Perfect for airport transfers, business trips, and personal travel."
    },
    {
      "name": "Pune One Way Outstation Cab",
      "description": "Planning a trip outside Pune? Our One Way Outstation Cab service provides comfortable and reliable transportation to major cities like Mumbai, Goa, Nashik, and more. Avoid the hassle of return journey bookings and travel stress-free with professional drivers familiar with all routes."
    },
    {
      "name": "One Way Cab from Pune to Mumbai",
      "description": "Travel from Pune to Mumbai conveniently with our one-way cab service. Whether for business or leisure, enjoy a smooth ride with clean vehicles, experienced drivers, and competitive fares. Book online to secure your Pune to Mumbai one-way cab quickly and easily."
    },
    {
      "name": "Pune One Way Airport Taxi",
      "description": "Catch your flight on time with our punctual Pune One Way Airport Taxi service. Available for both Pune Airport and Mumbai Airport transfers, our taxis ensure timely pickups, comfortable rides, and assistance with your luggage, making your airport journey seamless."
    },
    {
      "name": "One Way Taxi Service Pune",
      "description": "Our one way taxi service in Pune offers unmatched flexibility for travelers who prefer point-to-point travel. Perfect for solo travelers, families, or corporate clients, this service ensures you reach your destination on time with no need to book a return trip."
    },
    {
      "name": "Pune One Way Taxi Fare",
      "description": "We provide transparent and affordable one-way taxi fares in Pune, calculated based on distance and vehicle type. Get upfront pricing with no hidden costs, ensuring budget-friendly travel across local and outstation routes."
    },
    {
      "name": "Pune One Way Taxi Charges",
      "description": "Our Pune One Way Taxi Charges are competitive and designed to suit various budgets. We offer detailed fare breakdowns and flexible payment options, so you can plan your travel expenses with confidence."
    },
    {
      "name": "One Way Taxi Booking Online Pune",
      "description": "Secure your one-way taxi in Pune from the comfort of your home with our easy online booking system. Choose your pickup location, destination, vehicle type, and preferred time, and receive instant confirmation with driver details."
    },
    {
      "name": "One Way Taxi for Corporate Pune",
      "description": "Our corporate one-way taxi service in Pune caters to business travelers requiring efficient and professional transport. With well-maintained cars, timely service, and experienced chauffeurs, we ensure your corporate travel is seamless and comfortable."
    },
    {
      "name": "One Way Taxi for Family Pune",
      "description": "Travel with your family stress-free using our one-way family taxi service in Pune. Spacious vehicles, safety features, and courteous drivers make it an ideal choice for family outings, airport transfers, or holiday trips."
    },
    {
      "name": "One Way Taxi from Pune to Goa",
      "description": "Plan your next beach vacation effortlessly with our one-way taxi service from Pune to Goa. Enjoy a comfortable and scenic ride with reliable drivers and well-maintained cars, available at competitive prices for your convenience."
    }
  ],
  "tableData": [
    ["One Way Taxi Pune", "Pune One Way Cab Service"],
    ["One Way Car Rental Pune", "Affordable One Way Taxi Pune"],
    ["Pune One Way Taxi Booking", "Pune One Way Outstation Cab"],
    ["One Way Cab from Pune to Mumbai", "Pune One Way Airport Taxi"],
    ["One Way Taxi Service Pune", "Pune One Way Taxi Fare"],
    ["Pune One Way Taxi Charges", "One Way Taxi Booking Online Pune"],
    ["One Way Taxi for Corporate Pune", "One Way Taxi for Family Pune"],
    ["One Way Taxi from Pune to Goa", "—"]
  ],


         "whychoose": [
    {
      "WhyChooseheading": "Affordable One Way Taxi from Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers budget-friendly one way taxi services from Pune to multiple destinations across India."
    },
    {
      "WhyChooseheading": "Pay Only for the Distance You Travel",
      "WhyChoosedescription": "No need to pay for round trips—our one way taxi pricing is transparent and economical."
    },
    {
      "WhyChooseheading": "Wide Coverage of Popular Routes",
      "WhyChoosedescription": "Book one way cabs from Pune to Mumbai, Nashik, Aurangabad, Kolhapur, and more with ease."
    },
    {
      "WhyChooseheading": "Well-Maintained, Clean & Air-Conditioned Vehicles",
      "WhyChoosedescription": "Enjoy a safe and comfortable ride in sanitized cabs that are regularly inspected for quality."
    },
    {
      "WhyChooseheading": "Experienced Drivers for Safe and Reliable Travel",
      "WhyChoosedescription": "Our professional drivers are trained, verified, and familiar with the best one way routes."
    },
    {
      "WhyChooseheading": "24/7 Booking and Customer Support",
      "WhyChoosedescription": "Book your one way taxi from Pune anytime with round-the-clock assistance from our support team."
    },
    {
      "WhyChooseheading": "Multiple Cab Options to Suit Your Needs",
      "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and more depending on your budget and travel group."
    },
    {
      "WhyChooseheading": "Hassle-Free Online Booking with Instant Confirmation",
      "WhyChoosedescription": "Use our website or app to book your one way cab in minutes with instant booking confirmation."
    }
  ]









































    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide one-way taxi services from Pune?',
        answer: 'Yes, Platinum24 Cabs offers convenient and affordable one-way taxi services from Pune to various destinations.',
    },
    {
        question: 'How do I book a one-way taxi from Pune with Platinum24 Cabs?',
        answer: 'You can book a one-way taxi through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for one-way taxi trips from Pune?',
        answer: 'We offer a wide range of vehicles including sedans, SUVs, tempo travellers, and luxury cars for one-way journeys.',
    },
    {
        question: 'Are one-way taxi fares different from round-trip fares?',
        answer: 'Yes, one-way fares are calculated based on distance and duration for the single trip, typically making them more economical for one-way travel.',
    },
    {
        question: 'Can I customize pickup and drop locations for one-way taxi rides from Pune?',
        answer: 'Absolutely! You can specify your preferred pickup and drop-off points within Pune and the destination city.',
    },
    {
        question: 'Are drivers experienced for one-way trips from Pune?',
        answer: 'Yes, all our drivers are professional, experienced, and familiar with outstation routes originating from Pune.',
    },
    {
        question: 'Is advance booking recommended for one-way taxi services?',
        answer: 'We recommend advance booking to ensure vehicle availability and timely service for your one-way trip.',
    },
    {
        question: 'Does Platinum24 Cabs offer one-way taxi services for airport transfers from Pune?',
        answer: 'Yes, we provide efficient one-way taxi services for airport pickups and drop-offs from Pune.',
    },
    {
        question: 'Are safety and hygiene maintained during one-way taxi rides?',
        answer: 'All vehicles are sanitized regularly and drivers follow strict safety protocols to ensure your comfort and well-being.',
    },
    {
        question: 'Can I book a one-way taxi for corporate travel from Pune?',
        answer: 'Yes, we offer customized one-way taxi services tailored for corporate clients with priority support and flexible billing.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rohan Deshmukh',
        feedback: 'Booked a one-way taxi from Pune to Mumbai through Platinum24 Cabs. The ride was comfortable and the driver punctual.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Ananya Joshi',
        feedback: 'Excellent one-way taxi service from Pune. Smooth booking process and professional drivers.',
        rating: 5,
    },
];

















































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const oneWayTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Affordable and reliable One Way Taxi service from Pune, including airport transfers, corporate trips, family travel, and outstation cab bookings.",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "telephone": "+91-XXXXXXXXXX",
  "serviceType": [
    "One Way Taxi Pune",
    "Pune One Way Cab Service",
    "One Way Car Rental Pune",
    "Affordable One Way Taxi Pune",
    "Pune One Way Taxi Booking",
    "Pune One Way Outstation Cab",
    "One Way Cab from Pune to Mumbai",
    "Pune One Way Airport Taxi",
    "One Way Taxi Service Pune",
    "Pune One Way Taxi Fare",
    "Pune One Way Taxi Charges",
    "One Way Taxi Booking Online Pune",
    "One Way Taxi for Corporate Pune",
    "One Way Taxi for Family Pune",
    "One Way Taxi from Pune to Goa"
  ]
};






    return (
        <div>

<Helmet>
  <title>One Way Taxi from Pune | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Affordable and reliable One Way Taxi service from Pune, including airport transfers, corporate trips, family travel, and outstation cab bookings."
  />
  <meta
    name="keywords"
    content="One Way Taxi Pune, Pune One Way Cab Service, One Way Car Rental Pune, Affordable One Way Taxi Pune, Pune One Way Taxi Booking, Pune One Way Outstation Cab, One Way Cab from Pune to Mumbai, Pune One Way Airport Taxi, One Way Taxi Service Pune, Pune One Way Taxi Fare, Pune One Way Taxi Charges, One Way Taxi Booking Online Pune, One Way Taxi for Corporate Pune, One Way Taxi for Family Pune, One Way Taxi from Pune to Goa"
  />
  <script type="application/ld+json">
    {JSON.stringify(oneWayTaxiSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/46.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onewaytaxifrompune;